import * as React from "react";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import { useNotify } from "react-admin";
import { useAppDataProvider } from "../../dataprovider";

export const OldDataFileLink = ({ record }) => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();

  const getFile = () => {
    https: dataProvider
      .downloadOldDataFile(record?.fullName)
      .then((result: any) => {
        const data = result?.data;
        if (!data) {
          notify(`${record?.fullName} not found!`, { type: "info" });
          return;
        }
        downloadFile(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const downloadFile = data => {
    if (data instanceof Blob) {
      // Creating the blob file and its url
      var blob = new Blob([data], { type: data.type });
      let url = window.URL.createObjectURL(blob);

      // Creating the hyperlink and auto click it to start the download
      window.open(url); //show in new tab
      let link = document.createElement("a");
      link.href = url;
      link.target = "_blank"; //show in new tab
      link.download = `${record?.fullName}`;
      document.body.appendChild(link); //show in new tab
      link.click();
    }
  };

  return (
    <IconButton style={{ width: 40 }} onClick={getFile}>
      <Tooltip TransitionComponent={Zoom} title="File">
        <CloudDownload />
      </Tooltip>
    </IconButton>
  );
};

export default OldDataFileLink;
